import * as React from 'react';
import { connect } from 'react-redux';
import '../../StylingProjectMain.css';
import './StylingLanding.css';

class StylingLanding extends React.Component<any, any>  {
    constructor(props) {
        super(props);
    }
    public render() {
        return (
            <>
                <div className="styling-foundation-intro-page-header-container">
                    <span className="styling-foundation-intro-page-header">
                        SSP Styling
                        <br />
                        Foundation
                    </span>
                </div>
                <div id="appContainer" className="noProfile styling-project-intro">
                    <span className="styling-foundation-page-header">
                        SSP Styling Foundation
                    </span>
                    <p>
                        Please select the page you'd like to view from the <b>bottom left menu</b>.
                        <br />
                        PS: When adding new pages, please add them to <b>StartProcess.tsx and the Style Menu</b> and follow the
                       <b> StylePages/PageName folder structure.</b>
                    </p>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
      
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(StylingLanding)